import QuestionBreakdownReport from '../../../assignments/pages/ManageAssign/components/Reports/QuestionsBreakdownReport';
import { useGetAllAssignmentCumulativeReportMutation } from '../../../../features/authentication/reportApiSlice';
import { useReportContext } from '../../components/reportContext';
import { useSearchParams } from 'react-router-dom';

const AllAssignmentsCumilativeReport = () => {
  const [searchParams] = useSearchParams();
  const [getAllAssignmentCumulativeReport] = useGetAllAssignmentCumulativeReportMutation();
  var studentToIncludeTab = parseInt(searchParams.get('studentsToInclude'));
  const isTeacherReport = !isNaN(parseInt(studentToIncludeTab, 10));
  const reportContext = useReportContext();

  const getReportTitle = () => {
    if (isTeacherReport && reportContext) {
      if (studentToIncludeTab == 0)
        return reportContext.isAssessment ? 'All Students- All Assessments Report' : 'All Students- All Assignments Report';
      else if (studentToIncludeTab == 1)
        return reportContext.isAssessment ? 'Class- All Assessments Report' : 'Class- All Assignments Report';
      else
        return reportContext.isAssessment ? 'Student- All Assessments Report' : 'Student- All Assignments Report';
    }
    else
      return 'Cumulative Assignment Report';
  };

  const getReportType = () => {
    if(isTeacherReport && reportContext){
      if(reportContext.isAssessment){
        return 'Assessment';
      } else{
        return 'Assignment';
      }
    } else{
      return 'Session';
    }
  };

  var headerOptions = {
    reportTitle: getReportTitle(),
    showClassDropdown: false,
    showTeacherName: true,
    showStudentName: isTeacherReport ? (studentToIncludeTab == 0 || studentToIncludeTab == 2) : true,
    showClassName: isTeacherReport ? studentToIncludeTab == 1 : true,
    isAllStudentReport: false,
    showRetryInfo: true,
    showTotalRow: true,
    showReportType: false,
    reportType: getReportType()
  };

  return (
    <QuestionBreakdownReport
      isRetakeReport={false}
      exportFileName='ClassCumilativeReport'
      reportDataEndpoint={getAllAssignmentCumulativeReport}
      isTeacherReport={true}
      headerOptions={headerOptions}
      studentToIncludeTab={studentToIncludeTab}
      goBackOnError={true}
    />
  );

};

export default AllAssignmentsCumilativeReport;